import { GlobalHeader } from "./../models/global-header.model";
import { ResearchGridBase } from "./../models/research-grid-page.model";
import { ChartsPage } from "../models/charts-page.model";
import { LeftPanel } from "../models/global.model";
import { RightPanel } from "../models/right-panel-models";
import { GlobalSubheader } from "../models/global-subheader.model";
import { CompanyPage } from "../models/company-page-store.model";
import { NavigationSettings } from "../models/navigation-settings.model";
import { ExportToExcel } from "../models/export-to-excel.model";
import { SectorIndustry } from "../models/industry-page.model";
import { GlobalUserSettings } from "../models/global-user-settings.model";
import { PharmaDatabasePage } from "../models/pharma-page-store.model";
import { ComparativeAnalysis } from "../models/comparative-analysis.model";
export interface AppState {
  readonly globalHeader: GlobalHeader | object;
  readonly globalSubheader: GlobalSubheader | {};
  readonly researchBaseObj: ResearchGridBase | {};
  readonly chartsPage: ChartsPage | {};
  readonly leftPanel: LeftPanel;
  readonly rightPanel: RightPanel;
  readonly companyPage: CompanyPage | {};
  readonly navigationSettings: NavigationSettings;
  readonly exportToExcel: ExportToExcel;
  readonly sectorIndustry: SectorIndustry;
  readonly globalUserSettings: GlobalUserSettings;
  readonly pharmaDatabasePage: PharmaDatabasePage | {};
  readonly comparativeAnalysis: ComparativeAnalysis;
}

const getUnderlyingProperty = (currentStateLevel, properties: Array<any>) => {
  if (properties.length === 0) {
    throw "Unable to get the underlying property";
  } else if (properties.length === 1) {
    const key = properties.shift();
    return currentStateLevel[key];
  } else {
    const key = properties.shift();
    return getUnderlyingProperty(currentStateLevel[key], properties);
  }
};
/**
 * @param args List of keys for traversal in store
 * @description The arguments should follow the order in which the store is created.
 * Do not miss any keys in between
 * example : { test:{ a:[], b : { b1: 'Hi', b2: 'dev' }, c }}
 * to access b2 function call is to be stateGetter(test,b,b2)
 */
export const stateGetter = (...args) => {
  return (state: AppState) => {
    const argsCopy = args.slice();
    return getUnderlyingProperty(state, argsCopy);
  };
};
